import { ActionContext } from 'vuex';
import { BankAccountStoreState } from '@/interfaces/bank-account';
import { checkBankAccountDetails } from '@/api/account';

type Context = ActionContext<BankAccountStoreState, never>;

export async function getBankDetails(context: Context): Promise<void> {
  const { data } = await checkBankAccountDetails();
  context.commit('setBankAccountDetails', data);
}
